// extracted by mini-css-extract-plugin
export default {"content":"StarsSetting_content__+3sLf"};